<template>
    <div>
        <!-- filters -->
        <div>
            <heading-section :loading="isFetchingNews" class="d-flex">
                {{ $vuetify.lang.t('$vuetify.title.your_news') }}
            </heading-section>
            <v-row id="news-filter"
                   class="px-7 px-lg-0 mt-3"
                   dense
                   align="center"
                   no-gutters>
                <v-col cols="auto" class="flex-shrink-0 py-0">
                    <v-icon class="text-shadow--default" v-if="!isFetchingNews">mdi-filter-outline</v-icon>
                    <v-skeleton-loader type="avatar" v-else/>
                </v-col>
                <v-col lg="2" class="pl-2 pl-lg-3">
                    <item-filter type="select"
                                 @input="onChangeFilter('filterNewsCategory', $event)"
                                 :items="categories"
                                 item-text="name"
                                 item-value="id"
                                 :value="filterNewsCategory"
                                 v-if="!isFetchingNews"></item-filter>
                    <template v-else>
                        <v-skeleton-loader type="chip@3" tile class="d-flex"/>
                    </template>
                </v-col>
                <v-col cols="12" lg="auto" class="mt-2 mt-lg-0 pl-lg-4">
                    <item-filter type="chip"
                                 @input="onChangeFilter('filterNewsBrand', $event)"
                                 :items="brands"
                                 item-text="name"
                                 item-value="id"
                                 :item-reset-text="itemsResetText"
                                 :value="filterNewsBrand"
                                 v-if="!isFetchingNews"></item-filter>
                    <template v-else>
                        <v-skeleton-loader type="chip@3" class="d-flex"/>
                    </template>
                </v-col>
            </v-row>
        </div>
        <!-- /filters -->

        <!-- news-list -->
        <div class="mt-5">
            <template v-if="!isFetchingNews">
                <v-row no-gutters v-if="filteredArticles.length > 0">
                    <v-col cols="12" lg="6"
                           v-for="(article, index) in filteredArticles"
                           :key="article.id"
                           class="mb-2"
                           :class="{ 'pl-lg-1': index % 2 === 1, 'pr-lg-1': index % 2 !== 1 }">
                        <news-card :article="article"/>
                    </v-col>
                </v-row>
                <template v-else>
                    <info-card desc="$vuetify.news.filter-no-results"></info-card>
                </template>
            </template>

            <!-- skeleton loading -->
            <v-row no-gutters v-else>
                <v-col cols="12" lg="6"
                       v-for="(item, index) in filteredArticles"
                       :key="index"
                       :class="{ 'pl-lg-1': index % 2 === 1, 'pr-lg-1': index % 2 !== 1 }">
                    <v-card class="fill-height pa-2 mb-2"
                            flat
                            tile>
                        <v-row no-gutters class="align-center">
                            <v-col cols="4" class="flex-shrink-0">
                                <v-skeleton-loader type="image" tile/>
                            </v-col>

                            <v-col class="pt-0 pb-2 pl-3 pr-2">
                                <v-skeleton-loader type="heading" class="mb-2"/>
                                <v-skeleton-loader type="sentences" class="mb-3"/>
                                <v-skeleton-loader type="text@2"/>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>
            </v-row>
            <!-- /skeleton loading -->
        </div>
        <!-- /news-list -->
    </div>
</template>

<script>
    // 3rd
    import { mapState, mapActions } from 'vuex';
    // components
    import HeadingSection from '../components/HeadingSection';
    import ItemFilter from '../components/ItemFilter';
    import NewsCard from '../components/Cards/News';
    import InfoCard from '../components/Cards/Info';
    // models
    import News from '../models/News';
    import Brand from '../models/Brand';
    import NewsCategory from '../models/NewsCategory';
    // utils
    import { LOADER_FETCH_NEWS } from '../utils/constants';

    export default {
        name: 'news',
        components: {
            HeadingSection,
            NewsCard,
            ItemFilter,
            InfoCard,
        },
        computed: {
            ...mapState([
                'filterNewsCategory',
                'filterNewsBrand',
            ]),
            isFetchingNews() {
                return this.$wait.is(LOADER_FETCH_NEWS);
            },
            categories() {
                return [{ id: null, name: this.$vuetify.lang.t('$vuetify.form_items.all_news') }, ...NewsCategory.all()];
            },
            brands() {
                return Brand.all();
            },
            filteredArticles() {
                return News.getFiltered(this.filterNewsCategory, this.filterNewsBrand);
            },
            itemsResetText() {
                return this.$vuetify.lang.t('$vuetify.form_items.all_brands');
            },
        },
        methods: {
            ...mapActions([
                'setFilter',
            ]),
            onChangeFilter(i, v) {
                this.$vuetify.goTo('#news-filter', {
                    offset: document.querySelector('.ios-top-bar').offsetHeight,
                });
                this.setFilter({ item: i, value: v });
            },
        },
        mounted() {
            // News.fetch();
        },
    }
</script>
